module.exports = __webpack_public_path__ + "img/icon_group_3@2x.7f1acf26.png";